import React, { FC } from 'react'
import { Table } from 'reactstrap';
import { FormGroup } from 'reactstrap';
import { AEAField } from '@components/';
import { ProaSummaryPresenter } from '@presenters/screens/proa-summary.presenter';
import { ProjectBeneficiaries } from '@components/';

export interface IProjectIndicatorsProps {
    presenter: ProaSummaryPresenter;
};

const ProjectIndicators: FC<any> = (props: IProjectIndicatorsProps) => {
    return (
        <div>
            <Table bordered>
                <thead>
                    <tr>
                        <th className="text-center">{props.presenter.currentLabels.get('ProaFormTotalBeneficiarios')}</th>
                        <th className="text-center">{props.presenter.currentLabels.get('ProaFormHombresBeneficiarios')}</th>
                        <th className="text-center">{props.presenter.currentLabels.get('ProaFormMujeresBeneficiarios')}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{props.presenter.getTotalHyMDataFFRR().totalHombres + props.presenter.getTotalHyMDataFFRR().totalMujeres}</td>
                        <td>{props.presenter.getTotalHyMDataFFRR().totalHombres}</td>
                        <td>{props.presenter.getTotalHyMDataFFRR().totalMujeres}</td>
                    </tr>
                </tbody>
            </Table>
            <FormGroup>
                <AEAField {...props.presenter.getBeneficiaryDescriptionField} ></AEAField>
                <AEAField {...props.presenter.getBeneficiaryCollectiveField}></AEAField>
            </FormGroup>
            {(props.presenter.view.state.basicdataFFRR && props.presenter.view.state.proaSubproyect.length && props.presenter.view.state.beneficiariesDuplicates)
                ? <ProjectBeneficiaries summaryPresenter={props.presenter} basicData={props.presenter.view.state.basicdataFFRR} subProyect={props.presenter.view.state.proaSubproyect} duplicatesSP={props.presenter.view.state.beneficiariesDuplicates} ></ProjectBeneficiaries>
                :  null
            }
        </div>
    )
}

export default ProjectIndicators;
